import React, { useState } from "react";
import { ContainerBox, Content, Header, LogoName, OrDivider } from "./styles";
import CustomWebCam from "../../components/CustomWebCam";
import FileUpload from "../../components/FileUpload";
import { Button } from "@material-ui/core";
import event from "../../services/event";
import { base64ToFile } from "../../utils/Functions";

const Photo = () => {
    const [imgSrc, setImgSrc] = useState(null);
    const [file, setFile] = useState(null);
    const [mode, setMode] = useState(null); // 'capture', 'upload'
    const [fileNotFound, setFileNotFound] = useState(null);

    const handleCapture = async (src) => {
        console.log("handleCapture", { src });
        setMode("capture");
        setImgSrc(src);
        setFile(null);
    };

    const handleCaptureUpload = async (src) => {
        const file = base64ToFile(src, "captured-image.jpeg");
        await handleFileUpload(file);
    };

    const handleFileUpload = async (file) => {
        console.log("Arquivo a ser enviado:", file);

        if (file) {
            const formData = new FormData();
            formData.append("file", file);
            const response = await event.uploadPhoto("1", "8", formData);
            console.log("upload resp", { response });
        } else {
            setFileNotFound(true);
            console.log("FILE NOT FOUND");
        }
    };

    return (
        <ContainerBox>
            <Header>
                <LogoName>Evento</LogoName>
            </Header>
            <Content>
                {mode !== "upload" && (
                    <CustomWebCam setImage={handleCapture} setMode={setMode} onFileUpload={handleCaptureUpload} />
                )}
                {!mode && (
                    <OrDivider>
                        <h2>
                            <span>OU</span>
                        </h2>
                    </OrDivider>
                )}
                {mode !== "capture" && <FileUpload onFileUpload={handleFileUpload} setMode={setMode} />}
            </Content>
        </ContainerBox>
    );
};

export default Photo;
